export class UserDetail{
    public ID : Number;
      public Username : String;
      public ChangePassword : Boolean;
      public TeacherID : Number;
      public Name : String;
      public LastLoginDate : String;
      public LastLoginTime : String;
      public DefaultClassID : Number;
      public DefaultClass : String;
      public DefaultLevelID : Number;
      public DefaultLevel : String;
      public DefaultTermID : Number;
      public DefaultTerm : String;
      public DefaultPaymentType : String;
      public PasswordRecoveryOption : String;
      public GraphPallete : String;
      public PreferredScanner : String;
      public CommentsSource:String;
      public TermYears : Number;
      public CaptureHeadmasterComments : Boolean;
      public ProfileName : String;
      public Administration: Boolean;
      public Students: Boolean;
      public Fees: Boolean;
      public Exams: Boolean;
      public Communication: Boolean;
      public ResourceCentre: Boolean;
      public Reports: Boolean;
      public Maintenance: Boolean;
      public Settings: Boolean;
      public Library: Boolean;
      public Expenditure: Boolean;
      public Timetable: Boolean;
      public eLearning: Boolean;
      public Accomodation: Boolean;
      public Transport: Boolean;
}